import React from 'react';
import { Login, Link, LocalesMenuButton } from 'react-admin';
import Box from '@mui/material/Box';

const sx = {
	backgroundImage: `url(${process.env.PUBLIC_URL}/img/login.jpg)`,
	'& .MuiCard-root': {
		paddingBottom: (theme) => theme.spacing(2)
	},
	'& .RaLogin-avatar': {
		display: 'none'
	}
};

const CustomLogin = ({ children, ...props }) => (
	<>
		<Box sx={{ position: 'absolute', right: 0, color: '#FFF' }}>
			<LocalesMenuButton />
		</Box>
		<Login sx={sx} {...props}>
			<Box sx={{ textAlign: 'center' }} my={2}>
				<Link to="/login">
					<img src={`${process.env.PUBLIC_URL}/img/logo.svg`} alt="Europe Remembers" />
				</Link>
			</Box>
			{children}
		</Login>
	</>
);

export default CustomLogin;
